import { render, staticRenderFns } from "./Pricelists.vue?vue&type=template&id=029e7df8&"
import script from "./Pricelists.vue?vue&type=script&lang=ts&"
export * from "./Pricelists.vue?vue&type=script&lang=ts&"
import style0 from "./Pricelists.vue?vue&type=style&index=0&id=029e7df8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports